import { Breadcrumb as AntBreadcrumb } from "antd";
import BreadcrumbItem from "antd/lib/breadcrumb/BreadcrumbItem";
import React from "react";
import { withRouter, RouteComponentProps } from "react-router";
import { Link } from "react-router-dom";

import { SectionTemplateApi } from "lib/api";
import { CancellationToken } from "lib/api/base";
import { SectionTemplate } from "lib/data/model";
import { StateService } from "lib/services";

interface IBreadcrumbProps extends RouteComponentProps<MatchComponents> {

}

interface MatchComponents {
	id: string;
	sectionId?: string;
}

interface IBreadcrumbState {
	hierarchy: BreadCrumbData[];
}
class BreadCrumbData {
	constructor(name: string, link: string) {
		this.name = name;
		this.link = link;
	}
	name: string;
	link: string;
}

class BreadcrumbPreRouter extends React.Component<IBreadcrumbProps, IBreadcrumbState> {

	private apiCancellationToken: CancellationToken = new CancellationToken();

	constructor(props: IBreadcrumbProps) {
		super(props);
		this.state = {
			hierarchy: []
		}
	}

	public componentWillMount = () => {
		if (this.props.match.params.sectionId) {
			this.getHierarchy(this.props.match.params.sectionId);
		} else {
			this.getHierarchy(this.props.match.params.id);
		}
	}

	public componentWillReceiveProps = (nextProps: IBreadcrumbProps) => {
		if (this.props.match.params.sectionId && nextProps.match.params.sectionId) {
			const old_id = this.props.match.params.sectionId;
			const new_id = nextProps.match.params.sectionId;
			if (old_id != new_id) {
				this.getHierarchy(new_id);
			}
		} else {
			const old_id = this.props.match.params.id;
			const new_id = nextProps.match.params.id;
			if (old_id != new_id) {
				this.getHierarchy(new_id);
			}
		}
	}

	public componentWillUnmount() {

		// Cancel Outstanding API Calls
		this.apiCancellationToken.cancel();
	}

	getHierarchy = async (id: string) => {
		let sectionTemplates: SectionTemplate[] = await SectionTemplateApi.getSectionTemplateHierarchyById(id);
		if (this.props.match.params.sectionId) {
			const sectionTemplate = await SectionTemplateApi.getSectionTemplateById(Number(id), undefined);
			if (sectionTemplate) {
				sectionTemplates.push(sectionTemplate);
			}
		}
		const hierarchy: BreadCrumbData[] = sectionTemplates.map(sectionTemplate => {
			if (sectionTemplate.name == "Directory" || sectionTemplate.id == 1) {
				return new BreadCrumbData(sectionTemplate.name, `/admin/templateHierarchy/`);
			}
			return new BreadCrumbData(sectionTemplate.name, `/admin/templateHierarchy/${sectionTemplate.id}`);
		})
		StateService.setCancelableState(() => this.setState({ hierarchy }), this.apiCancellationToken);
	}
	getCurrentSectionItem = async () => {
		if (this.props.match.params.sectionId) {
			let sectionTemplate: SectionTemplate = await SectionTemplateApi.getSectionTemplateById(this.props.match.params.sectionId, undefined);
			return new BreadCrumbData(sectionTemplate.name, `/admin/templateHierarchy/${sectionTemplate.id}`);
		}
	}

	render() {
		return (
			<div className="breadcrumb">
				{this.state.hierarchy.length ?
					<AntBreadcrumb>
						{this.state.hierarchy.map((item, key) =>
							<BreadcrumbItem key={key}>
								<Link to={item.link}>
									{item.name}
								</Link>
							</BreadcrumbItem>
						)}

						<BreadcrumbItem>
							Current Location
                        </BreadcrumbItem>

					</AntBreadcrumb>
					: null}
			</div>
		);
	}
}

export const Breadcrumb = withRouter(BreadcrumbPreRouter);
